module.exports = __webpack_public_path__ + "static/media/forever_meow.895af0f7.png";